import { apiGet } from 'api';
import { GetParentOrganisationsResponse } from 'types';
import { GetParentOrganisationsRequest } from '../';

export const getParentOrganisations = (
  request: GetParentOrganisationsRequest
): Promise<GetParentOrganisationsResponse> =>
  apiGet<GetParentOrganisationsResponse, GetParentOrganisationsRequest>(
    'admin/parentorganisations',
    request
  );
